"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeGroup = void 0;
const types_1 = require("@hoepel.app/types");
const date_fns_1 = require("date-fns");
class AgeGroup {
    constructor(props) {
        this.props = props;
    }
    belongsToThisGroup(birthDate, switchOverOn, currentDate = types_1.DayDate.today()) {
        if (switchOverOn === 'childs-birthday') {
            const currentAge = date_fns_1.differenceInCalendarYears(currentDate.nativeDate, birthDate.nativeDate);
            return this.validForAges.has(currentAge);
        }
        else {
            const newSchoolYear = this.dateIsInNewSchoolYear(currentDate);
            const hasHadBirthDay = this.hasHadBirthDayThisYear(birthDate, currentDate);
            const currentAge = date_fns_1.differenceInCalendarYears(currentDate.nativeDate, birthDate.nativeDate);
            if (!newSchoolYear && hasHadBirthDay) {
                return this.validForAges.has(currentAge - 1);
            }
            else {
                return this.validForAges.has(currentAge);
            }
        }
    }
    static create(name, validForAges) {
        return AgeGroup.fromProps({
            name,
            validForAges: [...validForAges],
        });
    }
    static fromProps(props) {
        return new AgeGroup(props);
    }
    toProps() {
        return this.props;
    }
    withAgeAdded(age) {
        return AgeGroup.fromProps({
            ...this.toProps(),
            validForAges: [...new Set([...this.validForAges, age])],
        });
    }
    withAgeRemoved(age) {
        return AgeGroup.fromProps({
            ...this.toProps(),
            validForAges: [...this.validForAges].filter((a) => a !== age),
        });
    }
    withName(name) {
        return AgeGroup.fromProps({
            ...this.toProps(),
            name,
        });
    }
    agesOverlapWith(other) {
        const otherAges = [...other.validForAges];
        return new Set([...this.validForAges].filter((age) => otherAges.includes(age)));
    }
    hasHadBirthDayThisYear(birthDate, currentDate) {
        const daysSinceBirthday = date_fns_1.differenceInDays(currentDate.nativeDate, date_fns_1.setYear(birthDate.nativeDate, date_fns_1.getYear(currentDate.nativeDate)));
        return daysSinceBirthday >= 0;
    }
    dateIsInNewSchoolYear(date) {
        return date.month >= 9;
    }
    get name() {
        return this.props.name;
    }
    get validForAges() {
        return new Set(this.props.validForAges);
    }
}
exports.AgeGroup = AgeGroup;
//# sourceMappingURL=age-group.js.map